<template>
  <Modal :forceClose.sync="forceClose" amenities-updater :toggle.sync="toggle" :loading="loading">
    <template v-slot:header>Edit Amenity</template>

    <template v-slot:footer>
      <div :style="{ display: 'flex', justifyContent: 'end' }">
        <b-button amenity-updater-button class="is-primary" @click="update">Update</b-button>
      </div>
    </template>

    <valid-input
      amenity-name-input
      v-model="formData.name"
      label="Name"
      name="Name"
      placeholder="Name"
      spellcheck="true"
    />

    <br />

    <div>
      <label class="label pl-2"
        >Instructions
        <Info
          title="Steps"
          information="Steps for entering an amenity description"
          imageOnePath="markdown"
          titleOne="Step 1: Type the Description for your Amenity"
          infoOne="Enter the description for your amenity under the 'Markdown' tab. You don't have to use markdown markers. You can just type in regular text without any formatting. If you use markdown, then you can click on the helper buttons to insert the corresponding markdown symbols. The Preview tab will render your markdown symbols and allow you to view the description as it would appear for all readers of the description."
        />
      </label>
    </div>
    <div class="column is-12">
      <Markdown :message.sync="message" />
    </div>

    <br />

    <div
      :style="{
        display: 'flex',
        alignItems: 'center',
        minHeight: '50px',
        ...(breakpoint === 'desktop'
          ? {}
          : {
              flexDirection: 'column',
              alignItems: 'flex-start'
            })
      }"
    ></div>

    <br />

    <div :style="{ display: 'flex', alignItems: 'center', minHeight: '50px' }">
      <b-field>
        <b-checkbox amenity-approval-required-checkbox v-model="requiresApproval"
          >Requires Approval</b-checkbox
        >
      </b-field>
    </div>
  </Modal>
</template>

<script>
/*
  

*/

import Modal from '@/components/Modal'

import ValidInput from '@/components/inputs/ValidInput'

import { computed } from './keys/computed'
import { data } from './keys/data'
import { methods } from './keys/methods'
import Info from '@/components/icons/Info'
import Markdown from '@/components/markdown'

export default {
  components: {
    Modal,
    ValidInput,
    Info,
    Markdown
  },
  props: {
    toggle: Boolean,
    amenity: Object,
    forceClose: Boolean
  },
  mounted() {
    this.refresh()
  },
  computed,
  data,
  methods
}
</script>
